import { Route, Routes, Navigate } from "react-router-dom";
import Authorization from "./pages/Authorization";
import EmployeesTable from "./pages/EmployeesTable";
import { useIsAuthenticated } from "react-auth-kit";

const App = () => {
  const isAuthenticated = useIsAuthenticated();

  return (
    <Routes>
      <Route
        path="/"
        element={
          isAuthenticated() ? <EmployeesTable /> : <Navigate to="/login" />
        }
      ></Route>
      <Route path="/login" element={<Authorization />}></Route>
    </Routes>
  );
};
export default App;
